
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ProcurementTelegramNotify } from './ProcurementTelegramNotify';
import { TelegramNotificationHistory } from '../users/telegram/TelegramNotificationHistory';
import { ScheduledNotifications } from '../users/telegram/ScheduledNotifications';
import { Bell, Clock, CalendarClock } from 'lucide-react';
import { Procurement } from '@/types/database.types';

interface ProcurementTelegramTabProps {
  procurement: Procurement;
}

export function ProcurementTelegramTab({ procurement }: ProcurementTelegramTabProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Telegram Communications</CardTitle>
        <CardDescription>Send notifications and view communication history</CardDescription>
      </CardHeader>
      <CardContent>
        <Tabs defaultValue="send" className="space-y-4">
          <TabsList>
            <TabsTrigger value="send" className="flex items-center gap-1">
              <Bell className="h-4 w-4" />
              Send Notification
            </TabsTrigger>
            <TabsTrigger value="scheduled" className="flex items-center gap-1">
              <CalendarClock className="h-4 w-4" />
              Scheduled
            </TabsTrigger>
            <TabsTrigger value="history" className="flex items-center gap-1">
              <Clock className="h-4 w-4" />
              Notification History
            </TabsTrigger>
          </TabsList>
          
          <TabsContent value="send">
            <ProcurementTelegramNotify procurement={procurement} />
          </TabsContent>
          
          <TabsContent value="scheduled">
            <ScheduledNotifications procurementId={procurement.id} />
          </TabsContent>
          
          <TabsContent value="history">
            <TelegramNotificationHistory procurementId={procurement.id} />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
}
